import React, { lazy, Suspense } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import { AnalyticsTracker } from "./Analytics";

/*
const lazyLoad = (name, importer) =>
  React.lazy(() =>
    importer().then((module) => {
      if (!module.default) {
        console.error(`❌ Lazy component "${name}" has no default export`, module);
      } else {
        console.log(`✅ Loaded ${name}`);
      }
      return module;
    })
  );*/

const lazyLoad = (name, importer) =>
  React.lazy(() =>
    importer().then((module) => {
      console.log(name, module);

      if (!module.default) {
        console.error(`${name} has no default export`, module);
      }

      return module;
    })
  );

  
const Layout = lazy(() => import("./components/Layout"));

const Home = lazy(() => import("./pages/Home"));

const Kubernetes = lazyLoad(
  "Kubernetes",
  () => import("./components/Kubernetes")
);

const OpenStack = lazy(() => import("./components/OpenStack"));
const Openshift = lazy(() => import("./components/Openshift"));
const Proxmox = lazy(() => import("./components/Proxmox"));
const Terrabase = lazy(() => import("./components/Terrabase"));
const Ceph = lazy(() => import("./components/Ceph"));
const Cloud = lazy(() => import("./components/Cloud"));
const Database = lazy(() => import("./components/Database"));
const DevOps = lazy(() => import("./components/DevOps"));
const Observability = lazy(() => import("./components/Observability"));
const CloudNative = lazy(() => import("./components/CloudNative"));
const CloudSecurity = lazy(() => import("./components/CloudSecurity"));
const PlatformEngineering = lazy(() => import("./components/PlatformEngineering"));
const SiteReliabilityEngineering = lazy(() => import("./components/SiteReliabilityEngineering"));
const Postgresql = lazy(() => import("./components/Postgresql"));
const PostgresMigration = lazy(() => import("./components/migrateToPostgreSQL"));
const Services = lazy(() => import("./components/Services"));

const AWS = lazy(() => import("./components/AWS"));
const Azure = lazy(() => import("./components/Azure"));
const GoogleCloud = lazy(() => import("./components/GoogleCloud"));

const Blogs = lazy(() => import("./components/Blogs"));
const Blog = lazy(() => import("./components/Blog"));
const BlogsPreview = lazy(() => import("./components/BlogsPreview"));
const BlogPreview = lazy(() => import("./components/BlogPreview"));

const Casestudies = lazy(() => import("./components/Casestudy"));
const Case = lazy(() => import("./components/Case"));

const Glossary = lazy(() => import("./components/Glossary"));
const GlossaryTerm = lazy(() => import("./components/GlossaryTerm"));

const WhitePapers = lazy(() => import("./components/WhitePapers"));
const Whitepaper = lazy(() => import("./components/WhitePaper"));

const Vacancies = lazy(() => import("./components/Vacancies"));
const Vacancy = lazy(() => import("./components/Vacancy"));

const Webinars = lazy(() => import("./components/Webinars"));
const Webinar = lazy(() => import("./components/Webinar"));

const Careers = lazy(() => import("./components/Careers"));
const About = lazy(() => import("./components/About"));
const Contact = lazy(() => import("./components/Contact"));

const Login = lazy(() => import("./components/Login"));
const Reset = lazy(() => import("./components/Reset"));
const PasswordReset = lazy(() => import("./components/ResetPassword"));

const Chat = lazy(() => import("./components/chat"));
const Documents = lazy(() => import("./components/Documents"));
const AdminHome = lazy(() => import("./components/AdminHome.jsx"));
const Settings = lazy(() => import("./components/Settings"));

const CreateBlog = lazy(() => import("./components/CreateBlog"));
const EditBlogEditor = lazy(() => import("./components/EditBlog"));
const CreateTerm = lazy(() => import("./components/createTerm"));
const EditTermEditor = lazy(() => import("./components/EditTerm"));

const ManageBlogs = lazy(() => import("./components/ManageBlogs"));
const ManageTerms = lazy(() => import("./components/ManageTerms"));
const ManageUsers = lazy(() => import("./components/ManageUsers"));

const CreateVacancy = lazy(() => import("./components/createVacancy"));
const EditVacancyEditor = lazy(() => import("./components/editVacancy"));
const ManageVacancies = lazy(() => import("./components/ManageVacancies"));

const CreateWhitePaper = lazy(() => import("./components/CreateWhitePaper"));
const EditWhitePaperEditor = lazy(() => import("./components/EditWhitePaper"));
const ManageWhitePapers = lazy(() => import("./components/ManageWhitePapers"));

const CreateWebinar = lazy(() => import("./components/CreateWebinar"));
const EditWebinarEditor = lazy(() => import("./components/EditWebinar"));
const ManageWebinars = lazy(() => import("./components/ManageWebinars"));

const TestPage = lazy(() => import("./components/TestPage"));

const ManagedServices = lazy(() => import("./components/ManagedServices"));
const HealthChecks = lazy(() => import("./components/HealthChecks"));
const EmergencyAssistance = lazy(() => import("./components/EmergencyAssistance"));
const Training = lazy(() => import("./components/Training"));
const Consultancy = lazy(() => import("./components/consultancy"));

function PageLoader() {
    return (
        <div className="h-screen w-full flex items-center justify-center bg-gradient-to-tr from-[#100A33] via-[#101142] to-[#111B59]">
            <div className="flex flex-col items-center">

                <img
                    src="/logo_terravirt-removebg-preview.png"
                    alt="TerraVirt"
                    className="w-48 mb-8 animate-pulse"
                />

                <div className="relative h-10 w-10">
                    <div className="absolute inset-0 rounded-full border-4 border-white/20"></div>
                    <div className="absolute inset-0 rounded-full border-4 border-blue-400 border-t-transparent animate-spin"></div>
                </div>

                <p className="mt-5 text-gray-300 text-sm tracking-wide">
                    Loading...
                </p>

            </div>
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AnalyticsTracker />

            <Suspense fallback={<PageLoader />}>
                <Routes>

                    {/* Auth */}

                    <Route path="/login" element={<Login />} />
                    <Route path="/reset" element={<Reset />} />
                    <Route path="/resetPassword" element={<PasswordReset />} />

                    {/* Admin */}

                    <Route element={<Layout />}>

                        <Route path="/adminhome" element={<AdminHome />} />
                        <Route path="/chat" element={<Chat />} />
                        <Route path="/documents" element={<Documents />} />
                        <Route path="/settings" element={<Settings />} />

                        <Route path="/createblog" element={<CreateBlog />} />
                        <Route path="/editblog/:id" element={<EditBlogEditor />} />

                        <Route path="/createTerm" element={<CreateTerm />} />
                        <Route path="/editterm/:id" element={<EditTermEditor />} />

                        <Route path="/manageBlogs" element={<ManageBlogs />} />
                        <Route path="/manageTerms" element={<ManageTerms />} />
                        <Route path="/manageUsers" element={<ManageUsers />} />

                        <Route path="/createvacancy" element={<CreateVacancy />} />
                        <Route path="/editvacancy/:id" element={<EditVacancyEditor />} />
                        <Route path="/managevacancies" element={<ManageVacancies />} />

                        <Route path="/createwhitepaper" element={<CreateWhitePaper />} />
                        <Route path="/editwhitepaper/:id" element={<EditWhitePaperEditor />} />
                        <Route path="/managewhitepapers" element={<ManageWhitePapers />} />

                        <Route path="/createwebinar" element={<CreateWebinar />} />
                        <Route path="/editwebinar/:id" element={<EditWebinarEditor />} />
                        <Route path="/manageWebinars" element={<ManageWebinars />} />

                    </Route>

                    {/* Public */}

                    <Route path="/" element={<Home />} />

                    <Route path="/kubernetesconsulting" element={<Kubernetes />} />
                    <Route path="/openstackconsulting" element={<OpenStack />} />
                    <Route path="/openshiftconsulting" element={<Openshift />} />
                    <Route path="/proxmoxconsulting" element={<Proxmox />} />
                    <Route path="/terrabaseconsulting" element={<Terrabase />} />
                    <Route path="/cephstorage" element={<Ceph />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/managedservices" element={<ManagedServices />} />
                    <Route path="/healthcheck" element={<HealthChecks />} />
                    <Route path="/emergencyassistance" element={<EmergencyAssistance />} />
                    <Route path="/training" element={<Training />} />
                    <Route path="/Consultancy" element={<Consultancy />} />

                    <Route path="/cloudconsulting" element={<Cloud />} />
                    <Route path="/databaseconsulting" element={<Database />} />
                    <Route path="/devops" element={<DevOps />} />
                    <Route path="/observability" element={<Observability />} />
                    <Route path="/cloudnativedevelopment" element={<CloudNative />} />
                    <Route path="/cloudsecurity" element={<CloudSecurity />} />
                    <Route path="/platformengineering" element={<PlatformEngineering />} />
                    <Route path="/sitereliabilityengineering" element={<SiteReliabilityEngineering />} />
                    <Route path="/postgresql" element={<Postgresql />} />
                    <Route path="/migrate-to-postgresql" element={<PostgresMigration />} />

                    <Route path="/aws" element={<AWS />} />
                    <Route path="/azure" element={<Azure />} />
                    <Route path="/googlecloud" element={<GoogleCloud />} />

                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blog/:id" element={<Blog />} />

                    <Route path="/blogPreview/:id" element={<BlogPreview />} />
                    <Route path="/blogsPreview" element={<BlogsPreview />} />

                    <Route path="/webinars" element={<Webinars />} />
                    <Route path="/webinar" element={<Webinar />} />

                    <Route path="/vacancies" element={<Vacancies />} />
                    <Route path="/vacancy/:id" element={<Vacancy />} />

                    <Route path="/whitepapers" element={<WhitePapers />} />
                    <Route path="/whitepaper/:id" element={<Whitepaper />} />

                    <Route path="/casestudy" element={<Casestudies />} />
                    <Route path="/case" element={<Case />} />

                    <Route path="/glossary" element={<Glossary />} />
                    <Route path="/glossaryterm/:id" element={<GlossaryTerm />} />

                    <Route path="/about" element={<About />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route path="/testpage" element={<TestPage />} />

                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}